$('.js-scroll-link').on('click', function(e) {
  console.log('あああ')
  var speed = 400
  var href = $(this).attr('href')
  var target = $(href == '#' || href == '' ? 'html' : href)
  var position = target.offset().top
  $('html, body').animate({ scrollTop: position }, speed, 'swing')
  e.preventDefault()
})

// フェードインさせる
let fadeInTarget = document.querySelectorAll('.u-is--fade-in')
window.addEventListener('scroll', () => {
  for (let i = 0; i < fadeInTarget.length; i++) {
    const rect = fadeInTarget[i].getBoundingClientRect().top // ビューポートから要素の下部を取得
    // const scroll = window.pageYOffset || document.documentElement.scrollTop // スクロール量を取得
    // const offset = rect + scroll
    const windowHeight = window.innerHeight // 現在のブラウザの高さ
    // if (scroll > offset - windowHeight) {
    //   fadeInTarget[i].classList.add('u-is--scroll-in')
    // }
    if (windowHeight > rect + 150) {
      fadeInTarget[i].classList.add('u-is--scroll-in')
    }
  }
})
